import { TreeItem } from "./TreeItem";

export class Rbs extends TreeItem {
	public Children: Array<Rbs>;

	constructor() {
		super();
	}
}